module.exports = __webpack_public_path__ + "img/20200103155252848.5eabf2a0.jpg";